import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "merge-grid" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = ["rowspan", "colspan"]
const _hoisted_4 = { class: "cell" }
const _hoisted_5 = {
  key: 0,
  class: "application-item"
}
const _hoisted_6 = {
  key: 0,
  class: "item-actions"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "drag-handle" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "cell-action-split" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

import draggable from 'vuedraggable'
import { ref } from 'vue'
import Application, { getApplicationConfig, getApplicationDataCode } from '@/components/Application'
import { findRuntimeFileItem, isRuntimeFileItem } from '@/components/Application/runtime'
import { createDefaultGridData, normalizeMergeGridData } from './layout'
import { Delete, Rank, FullScreen } from '@element-plus/icons-vue'


export default {
  __name: 'index',
  props: {
  group: {
    type: String,
    default: '',
  },
  config: {
    type: Object,
    default: () => ({
      row: 2,
      col: 4,
    }),
  },
  data: {
    type: Array,
    default: () => null,
  },
  componentData: {
    type: Object,
    default: () => null,
  },
  componentProps: {
    type: Object,
    default: () => null
  },
  fileItems: {
    type: Array,
    default: () => []
  },
  // 是否开启合并操作
  mergeEnable: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // 是否拆分直接拆分成最小粒度，默认true
  splitToMin: {
    type: Boolean,
    default: true,
  },
},
  emits: ['change', 'cell-change', 'fullscreen'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const getDefaultData = () => createDefaultGridData(props.config.row, props.config.col)

const normalizeTableData = (data) => normalizeMergeGridData(data, props.config)

const tableData = ref(normalizeTableData(props.data))

const getFileItem = (item) => {
  if (!isRuntimeFileItem(item)) {
    return null
  }
  return findRuntimeFileItem(props.fileItems, item.id) || item || null
}

const resolveComponent = (item) => {
  if (!item) {
    return null
  }

  const fileItem = getFileItem(item)
  if (fileItem?.componentId) {
    return Application[fileItem.componentId]
  }

  return Application[item.id]
}

const getCellApplication = (item) => {
  const fileItem = getFileItem(item)
  if (fileItem) {
    return fileItem
  }
  return getApplicationConfig(item?.id)
}

const getComponentData = (item) => {
  const fileItem = getFileItem(item)
  if (fileItem) {
    return fileItem.viewerData || null
  }

  const componentTypeCode = getApplicationDataCode(item?.id)
  if (!componentTypeCode) {
    return null
  }
  return props.componentData?.[componentTypeCode] || null
}

// 拖拽添加组件, 触发数据更新事件
const handleDragAdd = (event, rowIndex, cellIndex) => {
  const addedItem = tableData.value[rowIndex][cellIndex]
  if (addedItem.items.length > 1) {
    const oldRowIndex = event.from.getAttribute('data-row-index')
    const oldCellIndex = event.from.getAttribute('data-cell-index')

    if (oldRowIndex && oldCellIndex) {
      tableData.value[oldRowIndex][oldCellIndex].items = [addedItem.items[event.newIndex === 0 ? 1 : 0]]
    }
    addedItem.items = [addedItem.items[event.newIndex]]
  }

  emit('change', tableData.value)
  emit('cell-change', {
    rowIndex,
    cellIndex,
    cell: tableData.value[rowIndex][cellIndex]
  })

  console.log(tableData.value)
}

// 全屏
const handleFullscreen = (rowIndex, cellIndex) => {
  emit('fullscreen', tableData.value[rowIndex][cellIndex])
}

// 移除单元格中的组件
const removeCellComponent = (rowIndex, cellIndex) => {
  if (!tableData.value[rowIndex] || !tableData.value[rowIndex][cellIndex]) return
  
  // 清除组件信息
  tableData.value[rowIndex][cellIndex].items = []
  
  // 触发数据更新事件
  emit('change', tableData.value)
  emit('cell-change', {
    rowIndex,
    cellIndex,
    cell: tableData.value[rowIndex][cellIndex]
  })
}

// 通过cell的colspan和config.col来获取td的宽度
const getCellWidth = (colspan) => {
  return `${100 / props.config.col * colspan}%`
}

// 获取右侧的单元格
const getColNextCell = (rowIndex, index, mergeEnable = false) => {
  const result = tableData.value[rowIndex]?.[index + 1]
  if (!result) {
    return null
  }
  if ((mergeEnable && !result?.isMerge) || (!mergeEnable && result?.isMerge)) {
    return getColNextCell(rowIndex, index + 1, mergeEnable)
  }
  return result
}

const showCellAction = (rowIndex, cellIndex, type, actionType) => {
  const cell = tableData.value[rowIndex][cellIndex]
  const rowNextCell = tableData.value[rowIndex + 1]?.[cellIndex]
  const colNextCell = tableData.value[rowIndex]?.[cellIndex + 1]
  const colNextCellNotMerge = getColNextCell(rowIndex, cellIndex)

  const showAction = () => {
    if (type === 'bottom') {
      return (rowIndex < props.config.row - 1)
    } else if (type === 'right') {
      return (cellIndex < props.config.col - 1)
    }
  }

  const mergeAction = () => {
    if (type === 'bottom') {
      return (cell.colspan === rowNextCell.colspan && !rowNextCell.isMerge)
    } else if (type === 'right') {
      const prevRowNextCell = tableData.value[rowIndex - 1]?.[cellIndex + 1]
      return (
        (colNextCellNotMerge && cell.rowspan === colNextCellNotMerge.rowspan && (!prevRowNextCell || prevRowNextCell.rowspan === 1)) ||
        (colNextCell.isMerge && (!prevRowNextCell?.isMerge && prevRowNextCell?.rowspan === colNextCell.rowspan && colNextCellNotMerge))
      )
    }
  }

  const splitAction = () => {
    if (type === 'bottom') {
      return (cell.rowspan > 1)
    } else if (type === 'right') {
      return (cell.colspan > 1)
    }
  }

  if (actionType === 'merge') {
    return showAction() && mergeAction()
  }

  if (actionType === 'split') {
    return splitAction()
  }

  return showAction() && (mergeAction() || splitAction())
}

// 合并单元格
const handleMerge = (rowIndex, cellIndex, type) => {
  const currentCell = tableData.value[rowIndex][cellIndex]

  switch (type) {
    case 'bottom':
      const bottomCell = tableData.value[rowIndex + 1][cellIndex]
      currentCell.rowspan += 1
      bottomCell.isMerge = true
      
      // 如果底部单元格有组件但当前单元格没有，则将组件移动到当前单元格
      if (bottomCell.items.length && !currentCell.items.length) {
        currentCell.items = [...bottomCell.items]
        bottomCell.items = []
      }
      
      break
    case 'right':
      const nextCell = getColNextCell(rowIndex, cellIndex)
      const rightCell = tableData.value[rowIndex][cellIndex + 1]
      if (!nextCell) return

      // 合并单元格
      nextCell.isMerge = true
      currentCell.colspan += rightCell.colspan
      if (rightCell.colspan > 1) {
        rightCell.colspan = 1
      }
      
      // 如果右侧单元格有组件但当前单元格没有，则将组件移动到当前单元格
      if (rightCell.items.length && !currentCell.items.length) {
        currentCell.items = [ ...rightCell.items ]
        rightCell.items = []
      }
      
      break
  }
  
  // 触发数据更新事件
  emit('change', tableData.value)
  console.log('tableData', tableData.value)
}

// 拆分单元格
const handleSplit = (rowIndex, cellIndex, type) => {
  switch (type) {
    case 'bottom':
      tableData.value[rowIndex + 1][cellIndex].isMerge = false
      tableData.value[rowIndex + 1][cellIndex].colspan = tableData.value[rowIndex][cellIndex].colspan
      tableData.value[rowIndex][cellIndex].rowspan -= 1
      
      // 清空拆分后单元格的组件信息，避免混淆
      tableData.value[rowIndex + 1][cellIndex].items = []
      break
    case 'right':
      tableData.value[rowIndex][cellIndex].colspan -= 1
      const splitIndex = cellIndex + tableData.value[rowIndex][cellIndex].colspan
      
      if (tableData.value[rowIndex][splitIndex]) {
        tableData.value[rowIndex][splitIndex].isMerge = false
        tableData.value[rowIndex][splitIndex].rowspan = tableData.value[rowIndex][cellIndex].rowspan
        
        // 清空拆分后单元格的组件信息，避免混淆
        tableData.value[rowIndex][splitIndex].items = []
      }
      break
  }
  
  // 触发数据更新事件
  emit('change', tableData.value)
  console.log('tableData', tableData.value)
}

// 拆分到最小粒度
const handleSplitToMin = (rowIndex, cellIndex) => {
  const newTableData = JSON.parse(JSON.stringify(tableData.value))
  const cell = JSON.parse(JSON.stringify(newTableData[rowIndex][cellIndex]))
  
  for (let i = 0; i < cell.rowspan; i++) {
    for (let j = 0; j < cell.colspan; j++) {
      // 主单元格保留组件信息，其他单元格重置
      if (i === 0 && j === 0) {
        newTableData[rowIndex][cellIndex].isMerge = false
        newTableData[rowIndex][cellIndex].rowspan = 1
        newTableData[rowIndex][cellIndex].colspan = 1
      } else {
        newTableData[rowIndex + i][cellIndex + j].isMerge = false
        newTableData[rowIndex + i][cellIndex + j].rowspan = 1
        newTableData[rowIndex + i][cellIndex + j].colspan = 1
        newTableData[rowIndex + i][cellIndex + j].items = []
      }
    }
  }
  
  tableData.value = newTableData
  
  // 触发数据更新事件
  emit('change', tableData.value)
}

// 清除单元格内容
const clearCellContent = (rowIndex, cellIndex) => {
  if (!tableData.value[rowIndex] || !tableData.value[rowIndex][cellIndex]) return
  
  // 清除组件信息
  tableData.value[rowIndex][cellIndex].items = []
  
  // 触发数据更新事件
  emit('change', tableData.value)
  emit('cell-change', {
    rowIndex,
    cellIndex,
    cell: tableData.value[rowIndex][cellIndex]
  })
}

// 提供一个外部方法来获取当前表格数据
const getTableData = () => {
  return normalizeTableData(JSON.parse(JSON.stringify(tableData.value)))
}

watch(() => props.data, (newVal) => {
  const normalizedData = normalizeTableData(newVal)
  if (JSON.stringify(normalizedData) !== JSON.stringify(tableData.value)) {
    tableData.value = normalizedData
    emit('change', tableData.value)
  }
})

// 暴露方法给父组件
__expose({
  clearCellContent,
  removeCellComponent,
  getTableData
})

return (_ctx, _cache) => {
  const _component_el_icon = _resolveComponent("el-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellIndex) => {
            return _withDirectives((_openBlock(), _createElementBlock("td", {
              key: cellIndex,
              rowspan: cell.rowspan,
              colspan: cell.colspan,
              style: _normalizeStyle({ width: !cell.isMerge ? getCellWidth(cell.colspan) : '' })
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(draggable), {
                  class: "drag-cell",
                  "data-row-index": rowIndex,
                  "data-cell-index": cellIndex,
                  modelValue: cell.items,
                  "onUpdate:modelValue": $event => ((cell.items) = $event),
                  group: { name: __props.group, put: true },
                  "item-key": "id",
                  onAdd: $event => (handleDragAdd($event, rowIndex, cellIndex)),
                  handle: '.drag-handle'
                }, {
                  item: _withCtx(({ element, index }) => [
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(resolveComponent(element)), _mergeProps({
                            readOnly: __props.mergeEnable,
                            data: getComponentData(element),
                            application: getCellApplication(element),
                            fileItem: getFileItem(element)
                          }, { ref_for: true }, __props.componentProps), null, 16, ["readOnly", "data", "application", "fileItem"])),
                          (!__props.disabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (!__props.mergeEnable)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "fullscreen-btn",
                                      onClick: _withModifiers($event => (handleFullscreen(rowIndex, cellIndex)), ["stop"])
                                    }, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(FullScreen))
                                        ]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_7))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Rank))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", {
                                  class: "remove-btn",
                                  onClick: _withModifiers($event => (removeCellComponent(rowIndex, cellIndex)), ["stop"])
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Delete))
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_9)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["data-row-index", "data-cell-index", "modelValue", "onUpdate:modelValue", "group", "onAdd"]),
                (__props.mergeEnable && !__props.disabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_10, [
                        (__props.splitToMin && (cell.rowspan > 1 || cell.colspan > 1))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: $event => (handleSplitToMin(rowIndex, cellIndex))
                            }, "拆分", 8, _hoisted_11))
                          : _createCommentVNode("", true),
                        (!__props.splitToMin && showCellAction(rowIndex, cellIndex, 'bottom', 'split'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              onClick: $event => (handleSplit(rowIndex, cellIndex, 'bottom'))
                            }, "纵向拆分", 8, _hoisted_12))
                          : _createCommentVNode("", true),
                        (!__props.splitToMin && showCellAction(rowIndex, cellIndex, 'right', 'split'))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              onClick: $event => (handleSplit(rowIndex, cellIndex, 'right'))
                            }, "横向拆分", 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      (showCellAction(rowIndex, cellIndex, 'bottom', 'merge'))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "cell-action-row",
                            onClick: $event => (handleMerge(rowIndex, cellIndex, 'bottom'))
                          }, " 合并 ", 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (showCellAction(rowIndex, cellIndex, 'right', 'merge'))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "cell-action-col",
                            onClick: $event => (handleMerge(rowIndex, cellIndex, 'right'))
                          }, " 合并 ", 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 12, _hoisted_3)), [
              [_vShow, !cell.isMerge]
            ])
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

}